module.exports = __webpack_public_path__ + "static/media/planilha.96bfd593.xlsx";